import React from "react";
import ReactDOM from "react-dom/client";
import { ClerkProvider } from "@clerk/clerk-react";
import "@/index.css";
import App from "@/App";

// Injected at build time by craco from CLERK_PUBLISHABLE_KEY (see craco.config.js).
// This is the *publishable* key — public by design. The secret key is server-side only.
const publishableKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

const root = ReactDOM.createRoot(document.getElementById("root"));

if (!publishableKey) {
  // Fail loudly rather than rendering an app that silently cannot authenticate.
  root.render(
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24 }}>
      <div style={{ maxWidth: 460, fontFamily: "monospace", color: "#ff6b6b", lineHeight: 1.6 }}>
        <strong>Sign-in is not configured.</strong>
        <p style={{ color: "#9aa4b2" }}>
          CLERK_PUBLISHABLE_KEY was missing when this build was made, so the console cannot
          authenticate anyone. Set it and rebuild.
        </p>
      </div>
    </div>
  );
} else {
  root.render(
    <React.StrictMode>
      <ClerkProvider publishableKey={publishableKey} afterSignOutUrl="/">
        <App />
      </ClerkProvider>
    </React.StrictMode>
  );
}
